import { render, staticRenderFns } from "./DeleteModalContent.vue?vue&type=template&id=f64087f0&scoped=true&"
import script from "./DeleteModalContent.vue?vue&type=script&lang=js&"
export * from "./DeleteModalContent.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModalContent.vue?vue&type=style&index=0&id=f64087f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64087f0",
  null
  
)

export default component.exports